module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"from":"From","to":"to","notProvided":"Salary not provided","year":"per year","month":"per month","week":"per week","day":"per day","hour":"per hour","net":"","gross":""}}')
  delete Component.options._Ctor
}
